import { NativeInvoiceCreatePrefill } from "@components/invoices/NativeInvoiceDrawer/nativeInvoiceFormTypes";

export interface BillableExpenseInvoicePrefillTransaction {
    id: number;
    amount: number;
    bankDescription: string;
    displayDescription: string | null;
    customerId?: string | null;
    billableExpenseInvoiceId?: string | null;
    customer?: {
        id: string;
        name: string;
    } | null;
    entity: {
        id: number;
        isBusiness: boolean;
    };
}

export function canInvoiceSelectedTransactionsToCustomer({
    selectedArray,
}: {
    selectedArray: BillableExpenseInvoicePrefillTransaction[];
}): boolean {
    if (selectedArray.length === 0) {
        return false;
    }

    const first = selectedArray[0];
    const customerId = first?.customerId ?? null;
    const customer = first?.customer ?? null;
    const entityId = first?.entity.id;

    return (
        customerId != null &&
        customer != null &&
        customer.id === customerId &&
        selectedArray.every(
            (transaction) =>
                transaction.entity.isBusiness &&
                transaction.entity.id === entityId &&
                transaction.customerId === customerId &&
                transaction.amount < 0 &&
                transaction.billableExpenseInvoiceId == null,
        )
    );
}

export function buildBillableExpenseInvoicePrefill(
    transactions: BillableExpenseInvoicePrefillTransaction[],
): NativeInvoiceCreatePrefill | null {
    if (
        !canInvoiceSelectedTransactionsToCustomer({
            selectedArray: transactions,
        })
    ) {
        return null;
    }

    const first = transactions[0];
    const customer = first.customer;

    return {
        entityId: first.entity.id,
        billableExpenseTransactionIds: transactions.map(
            (transaction) => transaction.id,
        ),
        customer: customer
            ? {
                  id: customer.id,
                  name: customer.name,
                  email: null,
                  phoneNumber: null,
              }
            : null,
        lines: [...transactions]
            .sort((left, right) => left.id - right.id)
            .map((transaction) => ({
                productOrService:
                    transaction.displayDescription ??
                    transaction.bankDescription,
                amount: Math.abs(transaction.amount),
                billableExpenseTransactionId: transaction.id,
            })),
    };
}
